<template>
  <div>
    <van-nav-bar
        left-arrow
        title="订单详情"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>
    <!--   ------ 三人团------->
    <div v-if="orderInfo.prodExtraFlag===10">
      <!-------- 到期关闭------->
      <div v-if="activeOverFlag===10">
        <van-row style="padding-top: 10px;text-align: center;font-weight: bold">
          <van-col span="7" class="runings">
            <van-icon name="thumb-circle-o" style="margin-right: 5px"/>
            发起3人团
          </van-col>
          <van-col span="1" class="runings_over">
            <van-icon name="arrow"/>
          </van-col>
          <van-col span="7" class="runings_over">
            <van-icon name="underway-o" style="margin-right: 5px"/>
            拼单邀请
          </van-col>
          <van-col span="1" class="runings_over">
            <van-icon name="arrow"/>
          </van-col>
          <van-col span="8" class="runings_over">
            <van-icon name="smile-o" style="margin-right: 5px"/>
            拼团成功
          </van-col>
        </van-row>
        <van-divider/>
        <div style="text-align: center">
          <van-image style="width: 40px;height: 40px;margin-right: 15px" round v-for="item in userImgs" :key="item"
                     :src="$getFileAccessHttpUrl(item)"></van-image>
        </div>
        <div style="text-align: center">
          需再<span style="color: red">邀请{{ 3 - activeCount }}人</span>
        </div>
      </div>
      <!--   ------ 拼团成功------->
      <div v-if="activeOverFlag===20">
        <van-row style="padding-top: 10px;text-align: center;font-weight: bold">
          <van-col span="7" class="runings_over">
            <van-icon name="thumb-circle-o" style="margin-right: 5px"/>
            发起3人团
          </van-col>
          <van-col span="1" class="runings_over">
            <van-icon name="arrow"/>
          </van-col>
          <van-col span="7" class="runings_over">
            <van-icon name="underway-o" style="margin-right: 5px"/>
            拼单邀请
          </van-col>
          <van-col span="1" class="runings_over">
            <van-icon name="arrow"/>
          </van-col>
          <van-col span="8" class="runings">
            <van-icon name="smile-o" style="margin-right: 5px"/>
            拼团成功
          </van-col>
        </van-row>
        <van-divider/>
        <div style="text-align: center;margin-bottom: -15px">
          <van-image style="width: 40px;height: 40px;margin-right: 15px" round v-for="item in userImgs" :key="item"
                     :src="$getFileAccessHttpUrl(item)"></van-image>
        </div>
      </div>
      <!--   ------ 拼单中------->
      <div v-if="activeOverFlag===0">
        <van-row style="padding-top: 10px;text-align: center;font-weight: bold">
          <van-col span="7" class="runings_over">
            <van-icon name="thumb-circle-o" style="margin-right: 5px"/>
            发起3人团
          </van-col>
          <van-col span="1" class="runings_over">
            <van-icon name="arrow"/>
          </van-col>
          <van-col span="7" class="runings">
            <van-icon name="underway-o" style="margin-right: 5px"/>
            拼单邀请
          </van-col>
          <van-col span="1" class="runings_over">
            <van-icon name="arrow"/>
          </van-col>
          <van-col span="8" class="runings_over">
            <van-icon name="smile-o" style="margin-right: 5px"/>
            拼团成功
          </van-col>
        </van-row>
        <van-divider/>
        <div style="text-align: center">
          <van-image style="width: 40px;height: 40px;margin-right: 15px" round v-for="item in userImgs" :key="item"
                     :src="$getFileAccessHttpUrl(item)"></van-image>
        </div>
        <div style="text-align: center">
          需再<span style="color: red">邀请{{ 3 - activeCount }}人，仅剩{{ daoJiShiString }}</span>
        </div>
      </div>
      <van-divider/>
    </div>

    <div class="balance_header" v-if="orderInfo">
      <div style="min-height:5px;"></div>
      <div style="margin: 10px;font-size: 14pt">
        <div>
          <van-row>
            <van-col span="12">已支付订单</van-col>
            <van-col span="12">
              <div style="text-align: right">{{ orderInfo.orderFlag === 20 ? '待服务' : '已服务' }}</div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div style="margin: 10px">
        <div>{{ orderInfo.payTime }}</div>
      </div>
      <div style="margin: 10px" v-if="orderInfo.typeFlag===2">
        <div>实收 ¥{{ departRealAmount }}</div>
      </div>
      <div style="margin: 10px" v-else>
        <div>爱心 {{ orderInfo.amount }}</div>
      </div>
    </div>
    <div style="margin: 20px 10px">
      会员/订单信息
      <div style="color: gray">
        <van-row class="user-links" style="padding-top: 10px">
          <van-col span="5">
            <div class="mt10">会员昵称</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ userBuy }}</div>
          </van-col>
          <van-col span="5">
            <div class="mt10">订单姓名</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ orderInfo.acceptName }}</div>
          </van-col>
          <van-col span="5">
            <div class="mt10">订单电话</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ orderInfo.acceptMobile }}</div>
          </van-col>
          <van-col span="5">
            <div class="mt10">订单地址</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ orderInfo.acceptAddress }}</div>
          </van-col>

          <van-col span="5">
            <div class="mt10">交易单号</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ ordersn }}</div>
          </van-col>
          <van-col span="5">
            <div class="mt10">下单时间</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ orderInfo.createTime }}</div>
          </van-col>
          <van-col span="5">
            <div class="mt10">用户备注</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ orderInfo.userRemark }}</div>
          </van-col>
          <van-col span="5">
            <div class="mt10">老板备注</div>
          </van-col>
          <van-col span="19" style="text-align: right;">
            <div class="mt10">{{ orderInfo.sysRemark }}
              <van-button type="default" v-if="!orderInfo.sysRemark" @click="showSysRemarkFun"
                          icon="edit" size="small"></van-button>
            </div>
            <van-button type="default" v-if="orderInfo.sysRemark" icon="edit" @click="showSysRemarkFun"
                        size="small"></van-button>
          </van-col>
        </van-row>
        <van-divider/>
      </div>
    </div>
    <div style="margin: 20px 10px">
      关联信息
      <div style="color: gray">
        <van-row class="user-links" style="padding-top: 10px">
          <van-col span="6">
            <div class="mt10">所属团长</div>
          </van-col>
          <van-col span="18" style="text-align: right;">
            <div class="mt10">{{ userWdName }}[{{ userWdId }}]</div>
          </van-col>
          <van-col span="6">
            <div class="mt10">扫的二维码</div>
          </van-col>
          <van-col span="18" style="text-align: right;">
            <div class="mt10">{{ userTgName }}[{{ userTgId }}]</div>
          </van-col>
        </van-row>
        <van-divider/>
      </div>
    </div>
    <div style="margin: 20px 10px">
      商品信息
      <div style="color: gray">
        <van-row class="user-links" style="padding-top: 10px">
          <van-col span="6">
            <div class="mt10">商品名称</div>
          </van-col>
          <van-col span="18" style="text-align: right;">
            <div class="mt10">{{ orderInfo.prodName }}*{{ orderInfo.prodCount }}</div>
          </van-col>
          <van-col span="6">
            <div class="mt10">价格</div>
          </van-col>
          <van-col span="18" style="text-align: right;" v-if="orderInfo.typeFlag===2">
            <div class="mt10">¥ {{ orderInfo.amount }}</div>
          </van-col>
          <van-col span="18" style="text-align: right;" v-else>
            <div class="mt10">爱心 {{ orderInfo.amount }}</div>
          </van-col>
        </van-row>
        <van-divider/>
      </div>
    </div>
    <!--    <div style="margin: 20px 10px">-->
    <!--      平台分账-->
    <!--      <div style="color: gray">-->
    <!--        <van-row class="user-links" style="padding-top: 10px">-->
    <!--          <van-col span="12">-->
    <!--            <div class="mt10">分账</div>-->
    <!--          </van-col>-->
    <!--          <van-col span="12" style="text-align: right;">-->
    <!--            <div class="mt10">¥{{ (backAdmin) }}</div>-->
    <!--          </van-col>-->
    <!--        </van-row>-->
    <!--        <van-divider/>-->
    <!--      </div>-->
    <!--    </div>-->
    <div style="margin: 20px 10px">
      用户支付
      <div style="color: gray">
        <van-row class="user-links" style="padding-top: 10px">
          <van-col span="12">
            <div class="mt10">实际支付</div>
          </van-col>
          <van-col span="12" style="text-align: right;" v-if="orderInfo.typeFlag===2">
            <div class="mt10">¥{{ (orderInfo.amount) }}</div>
          </van-col>
          <van-col span="12" style="text-align: right;" v-else>
            <div class="mt10">爱心 {{ (orderInfo.amount) }}</div>
          </van-col>
        </van-row>
        <van-divider/>
      </div>
    </div>
    <div style="margin: 16px;" v-if="orderInfo.orderFlag===20">
      <van-button
          round
          block
          type="danger"
          @click="confirmOrders()">
        服 务 完 成
      </van-button>
    </div>
    <van-popup v-model="showSysRemark" round position="bottom" :closeable="true" :style="{ height: '40%' }"
               safe-area-inset-bottom>
      <div style="margin-top: 20px;margin-left: 5px;margin-right: 5px">
        <van-field
            v-model="sysRemark"
            rows="3"
            autosize
            label="备注"
            type="textarea"
            maxlength="500"
            placeholder="请输入备注"
            show-word-limit
        />
      </div>
      <van-goods-action>
        <van-goods-action-button
            type="danger"
            text="保存备注"
            @click="saveRemark"
        />
      </van-goods-action>
    </van-popup>
  </div>
</template>

<script>
import {
  NavBar, Divider, Dialog, Popup, Sku, GoodsAction, GoodsActionIcon, GoodsActionButton,
  Button, Field, Tab, Tabs,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'
import {Toast} from 'vant';

export default {
  components: {
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Dialog.name]: Dialog,
    [Sku.name]: Sku,
    [List.name]: List,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [NavBar.name]: NavBar,
    [Card.name]: Card,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },

  data() {
    return {
      activeCount: 0,
      activeOverFlag:undefined,
      daoJiShiString: '',
      userImgs: [],
      activeOverTime: '',
      ordersn: this.$route.query.ordersn,
      orderInfo: 0,
      sysRemark: '',
      showSysRemark: false,
      userTgName: '',
      userWdName: '',
      userTgId: '',
      userWdId: '',
      backAdmin: 0,
      departRealAmount: 0,
      userBuy: '',
      kyz: this,
    }
  },
  mounted() {
    this.getOrderInfo()
  },
  methods: {
    showSysRemarkFun() {
      this.showSysRemark = true
    },
    getOrderInfo() {
      const that = this
      //发送 post 请求
      postAction('/web/api/manager/getMyOrderInfo', {ordersn: this.ordersn}).then(function (response) {
        console.log(response.result)
        that.activeOverTime = response.result.activeOverTime
        that.userImgs = response.result.userImgs
        that.activeCount = response.result.activeCount
        that.orderInfo = response.result.orderInfo
        that.userBuy = response.result.userBuy
        that.backAdmin = response.result.backAdmin
        that.departRealAmount = response.result.departRealAmount
        that.userWdName = response.result.userWdName
        that.userTgName = response.result.userTgName
        that.userWdId = response.result.userWdId
        that.userTgId = response.result.userTgId
        that.activeOverFlag=response.result.activeOverFlag
        if (that.orderInfo.sysRemark) {
          that.sysRemark = that.orderInfo.sysRemark
        }
      }).finally(() => {
      })
    },
    getDaoJiShi() {
      if (this.activeOverTime) {
        // 获取当前时间戳
        const now = +new Date()
        //获取未来某个时刻时间戳
        const end = +new Date(this.activeOverTime)
        const time = (end - now) / 1000
        // 获取 hour,min,second
        let hour = parseInt(time / 60 / 60 % 24)
        let min = parseInt(time / 60 % 60)
        let second = parseInt(time % 60)
        // 如果小于10的话，前面补零：8-》08
        hour = hour < 0 ? '00' : (hour < 10 ? '0' + hour : hour)
        min = min < 0 ? '00' : (min < 10 ? '0' + min : min)
        second = second < 0 ? '00' : (second < 10 ? '0' + second : second)
        this.daoJiShiString = hour + ":" + min + ":" + second
        if (this.daoJiShiString === '00:00:00') {
          clearTimeout(this.timer);
          this.getOrderInfo();
        }
      }
    },
    saveRemark() {
      const that = this
      postAction('/web/api/manager/saveSysRemark', {ordersn: this.ordersn, sysRemark: this.sysRemark}).then(function
          (response) {
        console.log(response.result)
        that.showSysRemark = false
        Toast("已保存")
        that.getOrderInfo()
      }).finally(() => {
      })
    },
    //确认订单
    confirmOrders() {
      const that = this
      Dialog.confirm({
        title: '',
        message: '确定服务完成了吗？',
      }).then(() => {
        // on confirm
        //发送 post 请求
        postAction('/web/api/manager/confirmOrder', {ordersn: that.ordersn}).then(function (response) {
          console.log(response.result)
          Toast("服务完成")
          that.getOrderInfo()
        }).finally(() => {
        })
      })
          .catch(() => {
            // on cancel
          });

    },
    times(t) {
      return '奖励日期：' + this.$formatDate(t, 'yyyy-MM-dd')
    },
    times2(t) {
      return '申请日期：' + this.$formatDate(t, 'yyyy-MM-dd')
    }
  }
}
</script>

<style lang="less" scoped>
.balance_header {
  background: url("/img/paysuccess-bg.png") no-repeat;
  background-size: 100%;
  height: 130px;
  color: white;
}
</style>
